import { DesignAction, DesignEvent, IPageControl } from "../../../base/models"
import { useEffect, useState } from "react"

import { ComponentStyle } from "../../styles"
import { IDataSource } from "../../../base/types"
import { PropertyBindings } from "./PropertyBindings"
import Tab from "react-bootstrap/esm/Tab"
import Tabs from "react-bootstrap/esm/Tabs"
import { useGetControlProperties } from "../hooks"

export const ControlProperties = ({ control, dataSource, onDesignChange }: {
    control: IPageControl,
    dataSource?: IDataSource,
    onDesignChange: (event: DesignEvent) => void
}) => {
    const { getProperties, properties } = useGetControlProperties();
    const [localControl, setLocalControl] = useState<IPageControl>(control)

    useEffect(() => {
        setLocalControl(control)
        getProperties(control.componentType)
        // eslint-disable-next-line
    }, [control])

    if (!localControl) return <></>

    return (
        <div className="card border-0 rounded-0 h-100">
            <div className="card-header min-h-60px border-0 px-5 mb-2">
                <div>
                    <h6 className="mt-5 mb-1">
                        <span>Properties</span>
                        <span className="badge badge-primary fw-semibold ms-3">
                            {localControl.componentType}
                        </span>
                    </h6>
                    <p className="fs-7 fw-semibold text-muted p-0 m-0">
                        <span>{localControl.componentName}</span>
                    </p>
                </div>
            </div>
            <div className="card-body px-2 pt-2 overflow-auto">
                <Tabs defaultActiveKey="styles" className="fs-8 fw-semibold">
                    <Tab title="Styles" eventKey="styles" className="my-3">
                        <ComponentStyle
                            control={localControl}
                            onDesignChange={onDesignChange} />
                    </Tab>
                    <Tab title="Bindings" eventKey="bindings">
                        <div className="m-3">
                            <PropertyBindings
                                bindings={localControl.bindings}
                                properties={properties}
                                dataSource={dataSource}
                                onChange={(bindings) => {
                                    setLocalControl({ ...localControl, bindings })
                                    onDesignChange({
                                        type: DesignAction.UpdateControl,
                                        control: { ...localControl, bindings }
                                    })
                                }} />
                        </div>
                    </Tab>
                </Tabs>
            </div>
        </div>
    )
}

